import { useLang, WHATSAPP, waLink } from "@/i18n";

const Footer = () => {
  const { t } = useLang();
  return (
    <footer className="relative border-t gold-hairline bg-[#08090D] py-16" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 grid md:grid-cols-3 gap-12">
        <div>
          <a href="#top" data-testid="footer-logo-link" className="flex items-center gap-3">
            <img src="/assets/logo.jpg" alt="Explore India" className="h-14 w-14 rounded-full object-cover ring-1 ring-gold/50" />
            <span className="leading-tight">
              <span className="block font-display text-xl font-semibold text-slate-100">Explore India</span>
              <span className="block text-[10px] uppercase tracking-[0.25em] text-gold/80 font-mono">exploreindians.com</span>
            </span>
          </a>
          <p className="mt-5 font-display text-lg italic text-gold-light/90">“{t.footer.tagline}”</p>
          <p className="mt-3 text-sm text-slate-500 leading-relaxed max-w-xs">{t.footer.blurb}</p>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.3em] text-gold/80 font-mono">{t.footer.explore}</h4>
          <ul className="mt-5 space-y-3">
            {[["#about", t.nav.about], ["#services", t.nav.services], ["#collections", t.nav.collections], ["#tours", t.nav.tours], ["#gallery", t.nav.gallery], ["#enquiry", t.nav.contact]].map(([href, label]) => (
              <li key={href}>
                <a href={href} data-testid={`footer-link-${href.slice(1)}`} className="text-sm text-slate-400 hover:text-gold-light transition-colors">
                  {label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.3em] text-gold/80 font-mono">{t.footer.contact}</h4>
          <ul className="mt-5 space-y-3" data-testid="footer-whatsapp-list">
            {WHATSAPP.map((w, i) => (
              <li key={w.num}>
                <a
                  href={waLink(i)}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`footer-whatsapp-${i}`}
                  className="text-sm text-slate-400 hover:text-gold-light transition-colors font-mono"
                >
                  {w.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="mt-14 border-t border-gold/10 pt-6 text-center">
        <p className="text-xs text-slate-600 font-mono tracking-wider">
          © {new Date().getFullYear()} Explore India · exploreindians.com — {t.footer.rights}
        </p>
      </div>
    </footer>
  );
};

export default Footer;
